import { render, staticRenderFns } from "./file_icon.vue?vue&type=template&id=35801e22&scoped=true"
import script from "./file_icon.vue?vue&type=script&lang=js"
export * from "./file_icon.vue?vue&type=script&lang=js"
import style0 from "./file_icon.vue?vue&type=style&index=0&id=35801e22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35801e22",
  null
  
)

export default component.exports